import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Home from '../views/Home.vue';
import FloorIndex from '../views/floors/index.vue';
import FloorMap from '../views/floors/map-floor.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/floor/index',
    name: 'FloorIndex',
    component: FloorIndex
  },
  {
    path: '/floor/map',
    name: 'FloorMap',
    component: FloorMap
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
